export const h = {	
	login:{		
			login:"Gabung",
			pleaseusername:"silakan masukkan nama pengguna",
			pleasepassword:"Silakan masukkan kata sandi",
			checkname:"Silakan masukkan nama pengguna yang benar",
			checkpass:"Kata sandi tidak boleh kurang dari 3 karakter",
		},	
	navbar:{	
		home:"halaman Depan",
		mycenter:"Pusat Pribadi",
		outlogin:"berhenti",
		close:"penutup",
		editLanguage:"bahasa penyuntingan",
	},	
	vip:{	
		nickname:"nama panggilan",
		pleasenickname:"Silakan masukkan nama panggilan",
		username:"nama belakang",
		pleaseusername:"silakan masukkan nama pengguna",
		arealogin:"Daerah masuk",
		pleasearealogin:"Silakan masuk ke area login Anda",
		nationality:"Warga Negara",
		pleasenationality:"Silakan pilih kewarganegaraan",
		depositstatus:"Status setoran",
		pleasedepositstatus:"Silakan pilih status setoran",
		createtime:"Waktu penciptaan",
		logintime:"Waktu masuk",
		startime:"Waktu mulai",
		endtime:"Akhir waktu",
		no:"nomor seri",
		shangji:"Rekomendasi langsung kepada atasan",
		keyongmoney:"Saldo Tersedia",
		baozhengjing:"batas",
		fudongyingkui:"Untung dan rugi mengambang",
		zicantotal:"Total aset",
		yaoqingma:"Kode undangan",
		zongrujing:"jumlah setoran",
		zongchujing:"Jumlah penarikan",
		loginIp:"IP masuk",
		zuihoulogin:"waktu masuk terakhir",
		shoucirujingmoney:"Jumlah setoran pertama",
		shoucirujingtime:"Waktu setoran pertama",
		kaitongtime:"Waktu pembukaan",
		keyong:"Tersedia",
		daoshi:"guru",
		dongjie:"membekukan",
		chujingstate:"Status penarikan",
		xiajichujingstate:"Status penarikan tingkat lebih rendah",
		caozuo:"beroperasi",
		chakan:"Memeriksa",
		heji:"total",
		moneytotal:"saldo keseluruhan",
		paixu:"menyortir",
		daochu:"Ekspor",
		huiyuanguanli:"Manajemen anggota",
		yonghu:"pengguna",
		search:"Pencarian kueri",
		reset:"mengatur ulang",
		delete:"menghapus",
		kickout:"Mengeluarkan",
		notlogin:"Belum masuk",
		editLanguage:"bahasa penyuntingan",
		yourujing:"Ada uang jaminan",
		wurujing:"Tanpa setoran",
    todayreg: "Volume registrasi hari ini: ",
    newvipnum: "Jumlah anggota VIP baru yang bergabung: ",
    juese: "peran",
    xiugaimima: "ubah kata sandi",
    jiumima: "kata sandi lama",
    shurujiumima: "masukkan kata sandi lama",
    xinmima: "kata sandi baru",
    shuruxinmima: "masukkan kata sandi baru",
    gerenzhongxing: "pusat pribadi",
    yonghuxinxi: "informasi pengguna"
	},	
	info:{	
		home:"Halaman beranda",
		user:"identitas pengguna",
		nickname:"nama panggilan",
		account:"akun",
		identity:"nomor ID",
		phone:"nomor telepon",
		nationality:"Warga Negara",
		Balance:"Manajemen keseimbangan",
		real:"akun nyata",
		zhongmongy:"saldo keseluruhan",
		keyongmoney:"Saldo Tersedia",
		jiaoyidongjie:"Transaksi dibekukan",
		shishilirun:"keuntungan waktu nyata",
		shishikeyong:"Tersedia dalam waktu nyata",
		xunizhanghu:"akun virtual",
		churujinguanli:"Manajemen setoran dan penarikan",
		chakanzijinjilu:"Lihat riwayat dana",
		rujinjilu:"Catatan setoran",
		rujinjine:"Jumlah setoran",
		jiaoyibishu:"Jumlah transaksi",
		chujinjilu:"Catatan penarikan",
		chujinjine:"Jumlah penarikan",
		jiaoyiguanli:"Pengelolaan transaksi",
		lishijilu:"catatan sejarah",
		chakanlishi:"Lihat informasi transaksi historis",
		jiaoyishoushu:"Banyak perdagangan",
		jiaoyiyingkui:"Perdagangan untung dan rugi",
		dangqianchicang:"Posisi saat ini",
		chakandangqianchicang:"Lihat informasi posisi saat ini",
		dangqianguadan:"Pesanan tertunda saat ini",
		chakanguadanliebiao:"Lihat daftar pesanan yang tertunda",
		guadanbishu:"Jumlah pesanan yang tertunda",
		yongjinguanli:"Manajemen komisi",
		duanwei:"pangkat",
		wu:"tidak ada",
		zhishushangji:"Atasan langsung",
		shangjidaili:"Agen unggul",
		xiajituandui:"Tim bawahan",
		shurudailiname:"Silakan masukkan nama agen",
		chakan:"Memeriksa",
		fanyongjie:"Jumlah rabat",
		fanyongbishu:"Jumlah rabat",
		chakanyongjinjilu:"Lihat catatan rabat",
		chakanyonghuinfo:"Lihat detail pengguna",
		chakanwenjuan:"Lihat kuesioner",
		resetpassword:"mengatur ulang kata sandi",
		sendmsg:"mengirim pesan",
		update:"Merevisi",
		unbound:"Tidak terikat",
		weishiming:"Tidak ada otentikasi nama asli",
		gendan:"Manajemen dokumentasi",
		gensui:"mengikuti",
		chakangendan:"Lihat catatan pesanan",
		dingdanhao:"jumlah order",
		shoudongpay:"Isi ulang secara manual",
		chakanyongjingjilu:"Lihat riwayat komisi",
		xiugaiyonghuxinxi:"Ubah informasi pengguna",
		queding:"Tentu",
		quxiao:"Membatalkan",
		email:"Surat",
		selguoji:"Silakan pilih kewarganegaraan",
		sendusermsg:"Kirim pesan ke pengguna",
		title:"judul",
		shurutitle:"Silakan masukkan judul pesan",
		content:"isi",
		shurucontent:"Silakan masukkan isi pesan",
		zhenshi:"realitas",
		xuni:"maya",
		fangxiang:"arah",
		zhanghu:"Akun",
		add:"Meningkatkan",
		less:"mengurangi",
		type:"jenis",
		guanliyuanpay:"Isi ulang administrator",
		pay:"isi ulang",
		money:"Jumlah",
		updategdmsg:"Ubah informasi pesanan",
		xinhaoyuan:"sumber sinyal",
		yes:"Ya",
		no:"TIDAK",
		updateyongjingmsg:"Ubah informasi komisi",
		qingxuanzejuese:"Silakan pilih peran akun",
		zuoduo:"Bersikaplah lama",
		zuokong:"pendek",
		gensuinicheng:"ikuti nama panggilan",
		kaicangjia:"harga pembukaan",
		pingcangjia:"Harga penutup",
		shousu:"Banyak ukuran",
		pingcangdate:"Tanggal pembukaan posisi",
		kaicangdate:"Tanggal Penutupan",
		chakangensuiinfo:"Lihat detail ikuti",
		gensuiuserno:"Ikuti nomor pengguna",
		gensuiyonghuname:"Ikuti nama panggilan pengguna",
		gensuifangshji:"ikuti metode",
		number:"kuantitas",
		danwei:"satuan",
		zhengxiang:"maju",
		fanxaing:"balik",
		beishu:"banyak",
		shousu:"Banyak ukuran",
		gensuizhuangtai:"mengikuti status",
		genjinzhong:"Lamaran menyusul",
		gensuiok:"Setuju untuk diikuti",
		gensuino:"Menolak untuk diikuti",
		chexiao:"Membatalkan",
		gensuidate:"mengikuti waktu",
		chakanlishijiaoyi:"Lihat informasi transaksi historis",
		chakanguadanlist:"Lihat daftar pesanan yang tertunda",
		heyue:"kontrak",
		daili:"akting",
		huiyuanname:"Nama anggota",
		xianjia:"batas harga",
		zhisun:"menghentikan kerugian",
		guadanjia:"harga pesanan tertunda",
		zhiyingzhisun:"Ambil untung dan hentikan kerugian",
		zhiyingjia:"Ambil harga untung",
		zhiyinghuichejia:"Harga retracement ambil untung",
		zhisunjia:"Hentikan harga kerugian",
		zhisunhuichejia:"Hentikan harga retracement kerugian",
		weiset:"tidak diatur",
		zt:"negara",
		chakanchicangmsg:"Lihat informasi posisi saat ini",
		shouyiId:"ID Penerima",
		xiajiid:"ID pengguna bawahan",
		xiajiuser:"Nama pengguna bawahan",
		fanyongmonney:"Jumlah rabat",
		tuihuibaozhengjing:"Setoran kembali",
		shouxufei:"Biaya penanganan",
		shouyi:"penghasilan",
		lixi:"Minat",
		zengmoney:"bonus",
		zhuijiabaozhengjing:"panggilan margin",
		fanyong:"Potongan harga",
		rujing:"Menyetorkan",
		chujing:"Tarik dana",
		chujingshibai:"Pengembalian dana jika peninjauan penarikan gagal",
		guanliyuanless:"Pengurangan Admin",
		pingzhong:"Variasi",
		shengqingzhong:"Melamar",
		wancheng:"Menyelesaikan",
		chongzhimima:"Penyetelan ulang kata sandi berhasil",
		copy:"menyalin",
		zhanghaomima:"kata sandi akun",
		fenye:"Artikel / Halaman",
    tixianmima:"Sandi tarik",
		gong:"umum",
		tiao:"mengupas",
		ye:"Halaman",
		goto:"Pergi ke",
		outtitle:"Anda telah keluar. Anda dapat membatalkan dan tetap berada di halaman ini atau masuk lagi.",
		outok:"Oke untuk logout",
		chongxingdenglu:"mendaftar ulang",
		cancel:"Membatalkan",
		pingtai:"platform",
		nodata:"Tidak ada data",
    shangjiID: "ID Atasan",
    shangjiaccount: "Akun Atasan",
    shangjiname: "Nickname Atasan",
    shangjinickname: "Nama Atasan",
    zhongyingkui: "Total Profit dan Loss",
    fuying: "Profit Mengambang",
    yue: "Saldo",
    sheng: "Urutan Meningkat",
    jiang: "Urutan Menurun"
	},	
	history:{		
			guadan:"Laba rugi",
			shijia:"pesanan tertunda",
			gendan:"harga pasar",
			dangqianjia:"Ikuti perintah",
			geyelixi:"harga sekarang",
			weituodate:"bunga semalam",
			pingcangfangshi:"Waktu komisi",
			dingdanyongjing:"Metode penutupan",
			shoudongpingcang:"Komisi pesanan",
			qiangzhipingcang:"Penutupan manual",
			gendanpingcang:"Likuidasi paksa",
			baocang:"Likuidasi",
			yuguqiangpingjia:"Ikuti perintah untuk menutup posisi",
			kaicangdiqu:"Perkiraan harga paritas paksa",
			ispingcang:"Daerah pembukaan",
			tips:"Apakah Anda yakin tentang likuidasi paksa?",
			pincangsucc:"petunjuk",
			queding:"Posisi berhasil ditutup",
			cancel:"Tentu"
		},	

	Langswitch: {	
	  "en":"Bahasa inggris",	
	  "id":"bahasa Indonesia",	
	  "th":"Bahasa Thailand",	
	  "vi":"Orang Vietnam",	
	  "zh":"Cina",	
	  "fa":"Perancis",	
	  "han":"Korea",	
	  "tu":"Turki",	
	  "pu":"Portugis",	
	  "xi":"Orang Spanyol",	
	  "jp":"Jepang",	
	  "ar":"Arab",	
	},	
}		



// WEBPACK FOOTER //
// ./src/i18n/langs/id.js